/* Pagina del carrito: cambios de cantidad por Cart AJAX API y refresco de la
   seccion por Section Rendering (sin recarga). */
const { mount, fetchSection } = window.EQ;

mount('[data-eq-cart]', (root) => {
  const sid = root.dataset.sectionId;
  let ocupado = false;
  const refrescar = async () => {
    const doc = await fetchSection(location.pathname, sid);
    const nuevo = doc.querySelector('[data-eq-cart]');
    if (nuevo) root.innerHTML = nuevo.innerHTML;
  };
  const onClick = async (e) => {
    const b = e.target.closest('[data-eq-line-mas], [data-eq-line-menos], [data-eq-line-rm]');
    if (!b || ocupado || !window.EQCart) return;
    const line = Number(b.dataset.eqLineMas || b.dataset.eqLineMenos || b.dataset.eqLineRm);
    const row = b.closest('[data-line]');
    const actual = Number(row.querySelector('[data-eq-line-qty]').textContent) || 1;
    let qty = actual;
    if (b.dataset.eqLineMas) qty = actual + 1;
    else if (b.dataset.eqLineMenos) qty = Math.max(0, actual - 1);
    else qty = 0;
    ocupado = true;
    root.style.opacity = '.6';
    try { await window.EQCart.change(line, qty); await refrescar(); }
    catch (err) { window.location.reload(); }
    finally { ocupado = false; root.style.opacity = ''; }
  };
  // si se cambia algo desde el cajon estando en esta pagina, la lista se pone al dia
  const onBolsa = () => { refrescar().catch(() => {}); };
  root.addEventListener('click', onClick);
  window.addEventListener('eq:bolsa-cambio', onBolsa);
  return () => { root.removeEventListener('click', onClick); window.removeEventListener('eq:bolsa-cambio', onBolsa); };
});
